"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useIsConnected(netinfo) {
    var _a = react_1.useState(undefined), isOnline = _a[0], setIsOnline = _a[1];
    react_1.useEffect(function () {
        function changeState(state) {
            var isConnected = state.isConnected;
            if (isConnected !== isOnline) {
                setIsOnline(isConnected);
            }
        }
        netinfo.fetch().then(changeState);
        return netinfo.addEventListener(changeState);
    }, []);
    return isOnline;
}
exports.useIsConnected = useIsConnected;
//# sourceMappingURL=useIsConnected.js.map